export default "__VITE_ASSET__FML2e9K2__"